import LiveTipsLeaderboardComponent from "./LiveTipsLeaderboardComponent";

export default LiveTipsLeaderboardComponent;